"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var Symbol = require("es6-symbol");
var _1 = require("./");
var TYPES = {
    FilesACLClient: Symbol("FilesACLClient"),
    FilesACLRoute: Symbol("FilesACLRoute"),
    FilesBatchRoute: Symbol("FilesBatchRoute"),
    FilesBatchClient: Symbol("FilesBatchClient"),
    FilesRoute: Symbol("FilesRoute"),
    FilesClient: Symbol("FilesClient"),
    FilesStreamsRoute: Symbol("FilesStreamsRoute"),
    FilesStreamsClient: Symbol("FilesStreamsClient")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.FilesBatchRoute).to(_1.FilesBatchRoute);
    bind(TYPES.FilesBatchClient).to(_1.FilesBatchClient);
    bind(TYPES.FilesStreamsRoute).to(_1.FilesStreamsRoute);
    bind(TYPES.FilesStreamsClient).to(_1.FilesStreamsClient);
    bind(TYPES.FilesACLRoute).to(_1.FilesACLRoute);
    bind(TYPES.FilesACLClient).to(_1.FilesACLClient);
    bind(TYPES.FilesRoute).to(_1.FilesRoute);
    bind(TYPES.FilesClient).to(_1.FilesClient);
});
exports.diModule = diModule;
